<template>
  <div class="resolve">
    <Reading
      v-if="detail.ielts_skill_id === SECTION.READING"
      :passageDetail="detail"
      :title="title"
      :lang="lang.value"
    />
    <Listening
      v-if="detail.ielts_skill_id === SECTION.LISTENING"
      :passageDetail="detail"
      :title="title"
      :lang="lang.value"
    />
    <Speaking
      v-if="detail.ielts_skill_id === SECTION.SPEAKING"
      :passageDetail="detail"
      :questionId="question_id"
      :examInfo="examInfo"
      :title="title"
      :lang="lang.value"
    />
    <Writing
      v-if="detail.ielts_skill_id === SECTION.WRITING"
      :passageDetail="detail"
      :questionId="question_id"
      :examInfo="examInfo"
      :title="title"
      :lang="lang.value"
    />
    <!-- <Review
      :questions="detail"
      :activeQuestionIndex="activeQuestionIndex"
    ></Review> -->
    <Lock
      ref="lock"
      :userExamId="user_exam_id"
      :examInfo="examInfo"
      :pointPackages="pointPackages"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import IELTS from "@/apis/ielts.js";
import Reading from "@/views/ielts/resolve/Reading";
import Listening from "@/views/ielts/resolve/Listening";
import Speaking from "@/views/ielts/resolve/Speaking";
import Writing from "@/views/ielts/resolve/Writing";
import Lock from "@/views/ielts/transcript/components/Lock";
import "./style.css";

export default {
  metaInfo() {
    return {
      title: `Explanation - ${this.title} | IELTS Mocks`
    };
  },

  components: {
    // Review,
    Reading,
    Listening,
    Speaking,
    Writing,
    Lock
  },
  mixins: [],
  props: [],
  data() {
    return {
      detail: {},
      examInfo: {},
      title: "",
      pointPackages: [],
      questions: [],
      passageDetail: null
    };
  },
  computed: {
    ...mapState("user", ["lang"]),
    examId() {
      return this.$route.query.exam_id;
    },
    user_exam_id() {
      return this.$route.query.user_exam_id;
    },
    question_id() {
      return Number(this.$route.query.question_id);
    },
    passage() {
      return this.$route.query.passage;
    },
    SECTION() {
      return {
        READING: 1,
        LISTENING: 2,
        SPEAKING: 3,
        WRITING: 4
      };
    }
  },
  watch: {},

  mounted() {
    this.getResolve();
    this.getTranscript();
  },

  methods: {
    getAlert() {
      this.$refs.lock.getAlert();
    },
    async getTranscript() {
      const res = await IELTS.getTranscript(this.user_exam_id);
      this.examInfo = res.exam_info;
    },
    async getResolve() {
      const res = await IELTS.getResolve(this.question_id, {
        user_exam_id: this.user_exam_id
      });
      this.detail = res.ielts_passages[0];
      this.detail.ielts_question_sets.forEach(group => {
        group.ielts_questions.forEach(question => {
          question["isReview"] = false;
          question["qNum"] = question.order;
        });
      });
    },
    titleCase(str) {
      let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
      return newStr;
    }
  }
};
</script>

<style scoped>
.resolve {
  background: #f2f3f5;
  position: absolute;
  top: 0;
  bottom: 0;
  padding-top: 100px;
  width: 100%;
}
</style>
